import React from 'react';
import ReactDOM from 'react-dom';
import { SlidersHorizontal } from 'lucide-react';

// Sits directly under the FloatingAIButton (same portal + container-relative
// coords). Offset = AI button height (~34px) + the requested 10px gap.
const AI_BUTTON_OFFSET = 44;

const FloatingImagePropsButton = ({ position, show, onClick, portalContainer }) => {
  if (!show || !position || !position.visible) return null;
  if (!portalContainer) return null;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const button = (
    <button
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      data-testid="floating-image-props-button"
      className="absolute bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 border border-slate-300 dark:border-slate-600 rounded-md px-2.5 py-1.5 shadow-lg hover:shadow-xl hover:bg-slate-100 dark:hover:bg-slate-700 transition-all cursor-pointer"
      style={{
        top: `${position.top + AI_BUTTON_OFFSET}px`,
        left: `${position.left}px`,
        pointerEvents: 'auto',
        zIndex: 30,
      }}
      title="Propiedades de imagen"
    >
      <SlidersHorizontal className="w-4 h-4" />
    </button>
  );

  return ReactDOM.createPortal(button, portalContainer);
};

export default FloatingImagePropsButton;
